import { FC } from 'react'
import Image from './Image'
import { Photo as PhotoType, ImageUrl, PhotoStyles, isRestPhoto, isJsonapiPhoto } from '@app-types/entity_types'

type PhotoProps = {
  photo: PhotoType
  thumbnailStyle: PhotoStyles
  className?: string
  loading?: 'lazy' | 'eager'
}

const Photo: FC<PhotoProps> = props => {
  const { photo, thumbnailStyle = 'medium', loading = 'lazy' } = props

  const getImagePropertiesForStyle = (style: PhotoStyles): ImageUrl | null => {
    if (!photo) return null

    if (isRestPhoto(photo)) {
      return photo.image_urls[style] ?? null
    }

    if (isJsonapiPhoto(photo)) {
      return photo.attributes.image_urls[style] ?? null
    }

    return null
  }

  const imageProperties = getImagePropertiesForStyle(thumbnailStyle)
  if (imageProperties) {
    const { src, width, height } = imageProperties
    if (src) {
      return <Image src={src} width={width} height={height} loading={loading} data-testid="qa-photo-preview" />
    }
  }
  return null
}

export default Photo
